import { render, staticRenderFns } from "./UploadInfo.vue?vue&type=template&id=5874b384&scoped=true&"
import script from "./UploadInfo.vue?vue&type=script&lang=js&"
export * from "./UploadInfo.vue?vue&type=script&lang=js&"
import style0 from "./UploadInfo.vue?vue&type=style&index=0&id=5874b384&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5874b384",
  null
  
)

export default component.exports